import React, { useEffect, useState } from 'react'
import GridItem from '../../../grid/GridItem'
import GridContainer from '../../../grid/GridContainer'
import CircularProgress from '@material-ui/core/CircularProgress'
import Backdrop from '@material-ui/core/Backdrop'
import MaterialTable from 'material-table'
import { createDateFromString } from '../../../utils/DateUtils'
import { getApiUrl } from '../../../../api/api'

const columns = [
  { field: 'surname', title: 'Nachname' },
  { field: 'name', title: 'Vorname' },
  { field: 'room', title: 'Zimmer' },
  { field: 'floor', title: 'Flur' },
  {
    field: 'movedIn',
    title: 'Einzug',
    customSort: (a, b) => createDateFromString(a.movedIn) - createDateFromString(b.movedIn),
  },
  {
    field: 'probationEnd',
    title: 'Probezeit',
    customSort: (a, b) => createDateFromString(a.probationEnd) - createDateFromString(b.probationEnd),
  },
  {
    field: 'movedOut',
    title: 'Auszug',
    customSort: (a, b) => createDateFromString(a.movedOut) - createDateFromString(b.movedOut),
  },
  { field: 'deposit', title: 'Kaution' },
  { field: 'email', title: 'Email', render: (rowData) => <a href={`mailto:${rowData.email}`}> {rowData.email} </a> },
  { field: 'telNumber', title: 'Telefonnummer' },
  { field: 'birthday', title: 'Geburt' },
  { field: 'gender', title: 'Geschlecht' },
  {
    field: 'nationality',
    title: 'Staatsangehörigkeit',
  },
  {
    field: 'university',
    title: 'Universität',
  },
  {
    field: 'studyField',
    title: 'Studienfach',
  },
]

export default function FutureTenantTable() {
  const [proceeding, setProceeding] = useState(true)

  const [tenants, setTenants] = useState([])

  useEffect(() => {
    setProceeding(true)
    getApiUrl({ type: 'newTenant' })
      .get(`/admin/tenants`)
      .then(function(response) {
        setProceeding(false)
        setTenants(response.data)
      })
      .catch(function(error) {
        setProceeding(false)
        console.log(error)
      })
  }, [])

  if (proceeding) {
    return (
      <Backdrop open={proceeding}>
        <CircularProgress color="inherit"/>
      </Backdrop>
    )
  }

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <MaterialTable
          columns={columns}
          data={tenants}
          title=""
          actions={[
            {
              icon: 'edit',
              tooltip: 'Eintrag bearbeiten',
              onClick: (event, rowData) => {
                window.open(`/admin/tenants/${rowData.tenantId}`, '_blank')
                event.stopPropagation()
              },
            },
          ]}
          options={{
            pageSize: 10,
            pageSizeOptions: [10, 30, 50],
            headerStyle: {
              fontWeight: 600,
            },
          }}
          localization={{
            header: {
              actions: 'Aktion',
            },
            pagination: {
              labelDisplayedRows: '{from}-{to} von {count}',
              labelRowsSelect: 'Einträge',
              labelRowsPerPage: 'Zeilen pro Seite',
            },
            toolbar: {
              nRowsSelected: '{0} Zeile(n) ',
              searchPlaceholder: 'Suchen',
              searchTooltip: 'Suchen',
            },
            body: {
              emptyDataSourceMessage: 'Keine Daten vorhanden.',
              filterRow: {
                filterTooltip: 'Filter',
              },
            },
          }}
        />
      </GridItem>
    </GridContainer>
  )
}
